import { render, staticRenderFns } from "./form-setting-layout.vue?vue&type=template&id=702752e2&scoped=true&"
import script from "./form-setting-layout.vue?vue&type=script&lang=js&"
export * from "./form-setting-layout.vue?vue&type=script&lang=js&"
import style0 from "./form-setting-layout.vue?vue&type=style&index=0&id=702752e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702752e2",
  null
  
)

export default component.exports